"use client";
import { useGenerator } from "@/app/context/GeneratorContext";

interface Props {
  gifLength: number;
}

export default function GifLengthToggle({ gifLength }: Props) {
  const { state, setGifLength } = useGenerator();

  const handleToggleClick = (gifLength: number) => {
    setGifLength(gifLength);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => handleToggleClick(gifLength)}
        style={{
          backgroundColor: state.gifLength === gifLength ? "#0772DD" : "#343639",
        }}
        className="mb-2 mr-2 rounded-full border-[0.5px] border-[#3C3C3C] px-3.5 py-[4px] text-sm font-medium text-white hover:bg-gray-900 hover:brightness-105 focus:outline-none focus:ring-0 focus:ring-gray-300 sm:px-5 sm:py-1.5 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
      >
        {gifLength}s
      </button>
    </>
  );
}
